<template lang="pug">
.col-md-6
  h3 {{ title }}
  .row.list.py-3(
    style="cursor: pointer",
    v-for="(article, index) in articleList",
    :class="{ last: index == articleList.length - 1 }",
    @click="toNewsDetail(article.id)"
  )
    .col-5.pic.d-flex.justify-content-center.align-items-center
      a
        img(v-if="article.photo", :src="article.photo.image")
    .col-7.d-flex.justify-content-center.align-items-center
      .text
        span.data {{ formatDate(article.created) }}
        h3
          a {{ article.title }}

  .d-flex.justify-content-end
    a.more(style="cursor: pointer", @click="toNews")
      | All
      font-awesome-icon.ml-1(
        :icon="['fas', 'caret-right']",
        data-toggle="tooltip",
        data-placement="right",
        title="All"
      ) 
</template>

<script>
import moment from "moment";

export default {
  name: "ArticleList",
  props: {
    title: String,
    articleList: Array,
    type: String,
  },
  methods: {
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    toNews() {
      this.$router.push({
        name: "News",
        params: {
          type: this.type,
        },
      });
    },
    toNewsDetail(id) {
      this.$router.push({
        name: "NewsDetail",
        query: {
          type: this.type,
          id: id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/home/article_list";
</style>
